export default {
  metrics: {
    nrr: {
      title: 'NRR % (Quartalsweise)',
      description:
        '(Abonnement-Einnahmen {{currentMonth}} (Q{{currentQuarter}}) + Einnahmen aus Servicegebühren {{currentMonth}} (Q{{currentQuarter}})) / (Abonnement-Einnahmen {{prevMonth}} (ende von Q{{prevQuarter}}) + Einnahmen aus Servicegebühren {{prevMonth}} (ende von Q{{prevQuarter}})) * 100',
    },
    upgrades: 'Account-Upgrades',
    downgrades: 'Account-Downgrades',
    gte_c_tier: 'Accounts ≥ C-Bewertung',
    churn: 'Churn (gekündigt)',
    offers_turned_on: 'Angebote aktiviert',
    flyers_sent: 'Flyer versendet',
    on_google_ads_trial: 'Im Google Ads-Test',
    converted_google_ads: 'Erfolgreich zu Google Ads konvertiert',
    first_time_500_monthly_sales: 'Erster €500-Monat',
    '14_days_no_sales': '14 Tage live, kein Umsatz',
  },
  details: {
    address: 'Adresse',
    subscriptions: 'Aktuelle Abonnements',
    best_sales: 'Bester Monat aller Zeiten',
    sales: '{{month}} Umsatz',
    tier: '{{month}} Stufe',
    live_from: 'Go-Live-Datum',
    owner_phone: 'Telefonnummer des Inhabers',
    owner_email: 'E-Mail des Inhabers',
    owner: 'Name des Inhabers',
    name: 'Restaurant',
    export_csv: 'CSV exportieren',
  },
  publish: 'Veröffentlichen',
  unpublish: 'Zurückziehen',
};
